<template>
    <div class="tableWithPerPageSelection pd-10px">
        <div class="columns level-right">
            <div class="columns">
                <div class="buttons column" v-if="!isCampagne">
                    <a @click="checkPermissions(constantes.DEMANDE_IMPRESSION.maj)
                            ? openDemandeImpressionPopUp() : showPopUp()"
                        class="button is-addOrEdit">
                        {{ $t('listeDemandeImpression.bouton.addDemandeImpression')}}
                    </a>
                </div>
                <div class="column">
                <exportExcelButton
                :perm="constantes.DEMANDE_IMPRESSION.exporter"
                :query="exportExcelQuery"/>
                </div>
                <b-field class="column" v-if="!isCampagne">
                    <b-checkbox-button
                        v-model="withoutImage"
                        type="is-primary"
                        outlined
                        @input="recherche">
                        <b-icon
                        :icon="withoutImage ? 'image-off-outline' : 'image-outline'"
                        class="mg-0">
                        </b-icon>
                    </b-checkbox-button>
                </b-field>
                <div class="column">
                <parametrage-table
                    :referenceTable="referenceTable"
                    @endLoadParamtre="startArrayRendering = true"/>
                </div>
            </div>
        </div>
        <v-server-table
        :columns="columns"
        :options="options"
        @loaded="finLoading"
        @loading="debutLoading"
        :ref="referenceTable"
        v-if="startArrayRendering">
        <template slot="dateDemande" slot-scope="props">
            <section class="is-flex is-justify-content-space-between has-text-left">
            <router-link-blank
                :to="{
                name: 'c.logistique.demande_impression',
                params: { id: props.row.id },
                }"
                :message="getDate(props.row.dateDemande)"/>
            <b-icon
                v-if="getCouleurInformation(props.row.couleur)"
                v-bind="getCouleurInformation(props.row.couleur)"
                size="is-small"
                class="mgl-1"/>
            </section>
        </template>
        <template slot="etat" slot-scope="props">
            <div class="has-text-left">
            {{ getEtatLibelle(props.row.etat) }}
            </div>
        </template>
        <template slot="client" slot-scope="props">
            <router-link-blank
            class="has-text-left"
            :to="{
                name: 'c.bodac.clients/contacts-client',
                params: { id: props.row.client.id },
            }"
            :message="props.row.client.nomCommercial"/>
        </template>
        <template slot="contactDemandeur" slot-scope="props">
            <router-link-blank
            v-if="props.row.contactDemandeur"
            class="has-text-left"
            :to="{
                name: 'c.bodac.clients/contacts-contacts',
                params: {
                id: props.row.contactDemandeur.id,
                isFromBailleur: false,
                },
            }"
            :message="func.getContactFullName(props.row.contactDemandeur)"/>
            </template>
        <template slot="dispositif" slot-scope="props">
            <router-link-blank
            v-if="props.row.dispositif"
            class="has-text-left"
            :to="{
                name: 'c.gabed.emplacement-detailDispositif',
                params: { idDispositif: props.row.dispositif.id },
            }"
            :message="props.row.dispositif.code"/>
        </template>
        <template slot="campagne" slot-scope="props">
            <router-link-blank
            v-if="props.row.campagne"
            class="has-text-left"
            :to="{
                name: 'c.bodac.campagne',
                params: { id: props.row.campagne.id },
            }"
            :message="props.row.campagne.libelle"/>
        </template>
        <template slot="image" slot-scope="props">
            <div class="has-text-centered">
            <image-view v-if="props.row.campagneId"
                :permission="constantes.DEMANDE_IMPRESSION"
                :image="props.row.cheminMin"
                :id="props.row.campagneId"
                :libelle="props.row.campagne.libelle || ' '"
                :maxSize="true"
            />
            </div>
        </template>
        <template slot="quantite" slot-scope="props">
            <div class="has-text-right">
                {{ props.row.quantite }}
            </div>
        </template>
        <template slot='afterTable'>
            <table-items-in-view
            :perPage="resultPerPage"
            @input="$refs[referenceTable].setLimit($event)"/>
        </template>
        <template slot='appendBody'>
            <table-footer-totaux
                ref="tableTotaux"
                :columns="columns"
                :target="targetTotal"
                :items="demandeImpressions"
                :formatage="formatTotaux">
            </table-footer-totaux>
        </template>
        </v-server-table>
        <b-modal v-model="popUpDisplayDemandeImpression" has-modal-card class="modal">
        <pop-up-edition-demande-impression
            v-if="tiersInformation"
            :fromClient="true"
            :clientProps="tiersInformation"
            @recherche="recherche"/>
        </b-modal>
    </div>
</template>

<script>
import exportExcelButton from '@/components/general/button/exportExcelButton';
import parametrageTable from '@/components/general/parametrageTable';
import formatDate from '@/services/general/formatDate';
import {
  SORT_ICON,
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import formatIsoDate from '@/services/general/formatIsoDate';
import { REFERENCE_TABLE_DEMANDE_IMPRESSION } from '@/configuration/general/referenceTableConf';
import { DEMANDE_IMPRESSION } from '@/configuration/logistique/permissionsLogistiqueConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import {
  COULEUR_IMPRESSION,
  ETAT_DEMANDE_IMPRESSION,
  COULEUR_BLANC,
} from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import { TYPOLOGIE_ENSEIGNE } from '@/configuration/tiers/tiersConf';
import { columnsSplice } from '@/services/general/columns';
import getContactFullName from '@/services/contact/contactHelper';
import imageView from '@/components/general/imageView';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import popUpEditionDemandeImpression
  from '@/components/commande/logistique/p_editionDemandeImpresssion';
import demandeImpressionStore from '@/store/modules/logistique/demandeImpression';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    isCampagne: {
      type: Boolean,
      default: false,
    },
    tiersInformation: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      demandeImpressionStore,
      constantes: {
        ETAT_DEMANDE_IMPRESSION,
        DEMANDE_IMPRESSION,
        COULEUR_IMPRESSION,
        COULEUR_BLANC,
        TYPOLOGIE_ENSEIGNE,
      },
      func: { getContactFullName },
      referenceTable: REFERENCE_TABLE_DEMANDE_IMPRESSION,
      startArrayRendering: false,
      resultPerPage: RESULTS_PER_PAGE,
      withoutImage: true,
      popUpDisplayDemandeImpression: false,
    };
  },
  components: {
    popUpEditionDemandeImpression,
    exportExcelButton,
    parametrageTable,
    TableItemsInView,
    routerLinkBlank,
    imageView,
    tableFooterTotaux,
  },
  computed: {
    storeName() {
      if (this.isCampagne) return 'demandeImpressionCampagne';
      return 'demandeImpressionClient';
    },
    critereRecherche: {
      get() {
        return this.$store.getters[`${this.storeName}/critereRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.storeName}/SET_CRITERES`, value);
      },
    },
    totalCount() {
      return this.$store.getters[`${this.storeName}/total`];
    },
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    demandeImpressions() {
      return this.$store.getters[`${this.storeName}/items`];
    },
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    columns() {
      const tab = [
        'dateDemande',
        'etat',
        'client',
        'contactDemandeur',
        'dispositif',
        'campagne',
        'image',
        'quantite',
      ];
      if (this.withoutImage) columnsSplice(tab, 'image');
      if (this.tiersInformation?.typologie !== this.constantes.TYPOLOGIE_ENSEIGNE && !this.isCampagne) columnsSplice(tab, 'client');
      if (this.isCampagne) columnsSplice(tab, 'campagne');
      return tab;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateDemande: this.$t('listeDemandeImpression.tabs.tabChildRow.date'),
          etat: this.$t('listeDemandeImpression.tabs.tabChildRow.etat'),
          contactDemandeur: this.$t('listeDemandeImpression.tabs.tabChildRow.demandeur'),
          dispositif: this.$t('listeDemandeImpression.tabs.tabChildRow.dispositif'),
          campagne: this.$t('listeDemandeImpression.tabs.tabChildRow.campagne'),
          client: this.$t('listeDemandeImpression.tabs.tabChildRow.client'),
          image: this.$t('listeDemandeImpression.tabs.visuelCampagne'),
          quantite: this.$t('listeDemandeImpression.tabs.tabChildRow.quantite'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.withoutImage = this.withoutImage;
          data.query = cloneDeep(this.critereRecherche);
          data.query.societeId = this.societeActiveId;
          if (data.query.dates.dateDebut && data.query.dates.dateFin) {
            data.query.dates.dateDebut = formatIsoDate(
              data.query.dates.dateDebut,
            );
            data.query.dates.dateFin = formatIsoDate(
              data.query.dates.dateFin,
            );
          }
          return this.loadDemandeImpression(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.demandeImpressions,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          image: 'width-50-percent',
          quantite: 'has-text-right',
        },
        sortable: ['dateDemande'],
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'demandeimpression',
        typeExport: '',
        filtres: this.lastPayload,
      };
    },
    targetTotal() {
      return ['quantite'];
    },
  },
  methods: {
    async loadDemandeImpression(data) {
      const res = await this.$store.dispatch(`${this.storeName}/loadDemandeImpression`, data);
      return res;
    },
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getDate(date) {
      return formatDate(date);
    },
    getEtatLibelle(etat) {
      const libelle = this.constantes.ETAT_DEMANDE_IMPRESSION.find(
        (etatDemandeImpression) => etat === etatDemandeImpression.key,
      );
      return libelle ? this.$t(libelle.libelle) : '';
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    openDemandeImpressionPopUp() {
      this.popUpDisplayDemandeImpression = true;
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    getCouleurInformation(couleur) {
      const color = this.constantes.COULEUR_IMPRESSION.find(
        (couleurImpression) => couleur === couleurImpression.key,
      );
      return color ? {
        icon: color.icon,
        customClass: color.type,
        class: color.key === this.constantes.COULEUR_BLANC ? 'demandeImpressionwhiteColorBorder' : '',
      } : null;
    },
    formatTotaux(value) {
      return value;
    },
  },
};
</script>
